// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .warning-row {\n  background: oldlace;\n}\n.el-table .danger {\n  background: #5858583b;\n}\n.padding {\n  padding: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
